import styled from "styled-components";

const WarningMessage = styled.div`
  position: absolute;
  top: -20px;
  right: 0;
  background-color: #F7DC6F;
  border: 1px solid rgb(161, 98, 7);
  color: rgb(161, 98, 7);
  padding: 4px 2px;
  border-radius: 8px;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 12px;
`

export default WarningMessage;

